import { ICON__circle_info } from '@/assets/icons_fa';
import { useToast } from '@/hooks/use-toast';
import { FIELD__base } from '@shared/dto/generation/graph_invoke/_fields/_base/FIELD__base';
import { CONTEXT_MENU_ITEM__field_base } from '../_base/CONTEXT_MENU_ITEM__field_base';

interface PROPS {
  field: FIELD__base;
}

export function CONTEXT_MENU_ITEM__field_info_hash({ field }: PROPS) {
  const { toast } = useToast();

  /*
   * EVENTS
   */

  async function on_click() {
    await navigator.clipboard.writeText(field.meta.field_hash__value_full);

    toast({ title: 'Copied to clipboard' });
  }

  /*
   * HTML
   */

  return <CONTEXT_MENU_ITEM__field_base Icon={ICON__circle_info} {...{ on_click }} text={'Field hash'} />;
}
